import { FC, useRef, useState } from 'react';
import { IFinancialResult } from '../types';
import FinancialRowsTitles from './FinancialRowsTitles';
import FinancialNavigationBtns from './FinancialNavigationBtns';
import FinancialYearCalendar from './FinancialYearCalendar';
import Slider from 'react-slick';

// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ITEMS_PER_PAGE = 3;

interface IProps {
  financialResultsArr: IFinancialResult[];
}

const FinancialDesktopCalendars: FC<IProps> = ({ financialResultsArr }) => {
  const sliderRef = useRef<Slider>(null);

  // If items count is less than ITEMS_PER_PAGE then empty gap appears on slider track
  // Set the lowest value of both
  const itemsToShow = Math.min(ITEMS_PER_PAGE, financialResultsArr.length);

  const pagesCount = Math.ceil(financialResultsArr.length / itemsToShow);

  const [currentPageNumber, setCurrentPageNumber] = useState(0);

  const onPrev = () => {
    if (currentPageNumber > 0) {
      sliderRef?.current.slickPrev();
    }
  };

  const onNext = () => {
    if (currentPageNumber < pagesCount - 1) {
      sliderRef?.current.slickNext();
    }
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: itemsToShow,
    slidesToScroll: itemsToShow,
    ref: sliderRef,
    afterChange: (currentSlide: number) =>
      setCurrentPageNumber(Math.ceil(currentSlide / itemsToShow)),
  };

  return (
    <div className="financial-results__table">
      <FinancialRowsTitles />
      <FinancialNavigationBtns
        currentPageNumber={currentPageNumber}
        onNext={onNext}
        onPrev={onPrev}
        pagesCount={pagesCount}
      >
        <div className="financial-results__slider-container">
          <Slider {...settings}>
            {financialResultsArr.map(({ year, documents }) => (
              <div key={year}>
                <FinancialYearCalendar year={year} yearDocuments={documents} />
              </div>
            ))}
          </Slider>
        </div>
      </FinancialNavigationBtns>
    </div>
  );
};

export default FinancialDesktopCalendars;
